"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubRisqueRendementCorporationTrads = void 0;
exports.ESubRisqueRendementCorporationTrads = {
    eleve: "Élevé - Une prise de risque importante (perte totale du capital)",
    faible: "Faible - Une prise de risque limitée (perte minime du capital)",
    moyen: "Moyen - Une prise de risque modérée (perte de capital acceptée)",
    null: "Nul - Aucune prise de risque ",
};
